module.exports = __webpack_public_path__ + "img/image_happy_turn.b35a190d.png";